module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Back-8331f9df17d921c805241cb32c1e1708.svg";